import { render, staticRenderFns } from "./MessageListPC.vue?vue&type=template&id=6b0ce451&scoped=true"
import script from "./MessageListPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageListPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MessageListPC.vue?vue&type=style&index=0&id=6b0ce451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ce451",
  null
  
)

export default component.exports